export interface UserEntityFeatures {
  isNotificationsEnabled: boolean;
  isChatNotificationsEnabled: boolean;
  allowManualLoadCreation: boolean;
  isCounterOfferEnabled: boolean;
}
